export default __webpack_public_path__ + "static/media/15.c60291ff.jpg";